import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { InputButtonIcon } from "./InputButtonIcon";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
var emptyCallback = function emptyCallback() {
  return undefined;
};
export var InputButton = /*#__PURE__*/function (_Component) {
  _inherits(InputButton, _Component);
  var _super = _createSuper(InputButton);
  function InputButton() {
    _classCallCheck(this, InputButton);
    return _super.apply(this, arguments);
  }
  _createClass(InputButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        value = _this$props.value,
        clearable = _this$props.clearable,
        hidePassword = _this$props.hidePassword,
        size = _this$props.size,
        onClick = _this$props.onClick,
        title = _this$props.title;
      var isDisabled = !value;
      if (type === 'password') {
        isDisabled = false;
      }
      return /*#__PURE__*/React.createElement("button", {
        className: cx('inputButton'),
        disabled: isDisabled,
        onClick: onClick,
        title: title,
        type: "button"
      }, /*#__PURE__*/React.createElement(InputButtonIcon, {
        clearable: clearable,
        hidePassword: hidePassword,
        size: size,
        type: type,
        value: value
      }));
    }
  }]);
  return InputButton;
}(Component);
_defineProperty(InputButton, "defaultProps", {
  type: 'text',
  value: '',
  clearable: false,
  hidePassword: false,
  size: 'default',
  title: '',
  onClick: emptyCallback
});
InputButton.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clearable: PropTypes.bool,
  hidePassword: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  size: PropTypes.oneOf(['default', 'big'])
} : {};